<script>
import { BModal, BForm } from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import { convertSecondsToTime, convertTimeToSeconds } from '@/@core/utils/utils'
import store from '@/store'

export default {
  components: { BModal, BForm, Cleave },
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      step: 1,
      totalSteps: 4,
      isValidForm: true,
      triggerEnd: false,
      positionNames: {
        tl: 'Superior Esquerdo', tc: 'Superior Centro', tr: 'Superior Direito',
        cl: 'Centro Esquerdo',   cc: 'Centro',          cr: 'Centro Direito',
        bl: 'Inferior Esquerdo', bc: 'Inferior Centro',  br: 'Inferior Direito',
      },
      steps: [
        { icon: 'grid',   label: 'Posição'   },
        { icon: 'text',   label: 'Conteúdo'  },
        { icon: 'clock',  label: 'Timing'    },
        { icon: 'palette',label: 'Visual'    },
      ],
    }
  },
  computed: {
    showModal: {
      get() { return this.value },
      set(val) { this.$emit('input', val) },
    },
    formButtonAction: {
      get() { return this.$store.state.callActions.callAction },
      set(val) { this.$store.commit('callActions/SET_CALL_ACTION', val) },
    },
    opacityBtn() { return this.$store.getters['callActions/getOpacityBtn'] },
    isEdit()      { return this.formButtonAction && this.formButtonAction.id !== null },
    durationVideo() { return store.getters['Videos/getVideoEditAtual'].duration },
    isLastStep()  { return this.step === this.totalSteps },
    isFirstStep() { return this.step === 1 },
  },
  watch: {
    formButtonAction: {
      handler(v) {
        if (v && v.background_hover_color) {
          document.documentElement.style.setProperty('--bg-hover-btn-custom', v.background_hover_color)
        }
      },
      deep: true,
    },
  },
  methods: {
    nextStep() { if (this.step < this.totalSteps) this.step++ },
    prevStep() { if (this.step > 1) this.step-- },
    selectPosition(pos) { this.formButtonAction.position = pos },
    toggleTriggerEnd() {
      this.triggerEnd = !this.triggerEnd
      this.formButtonAction.end = this.triggerEnd ? 'Infinito' : ''
    },
    changeSize(size) {
      this.formButtonAction.size = size
      const el = document.getElementById('btn-preview')
      if (!el) return
      el.classList.forEach(c => { if (c.startsWith('vslbooster-call-action__size_btn_')) el.classList.remove(c) })
      el.classList.add(`vslbooster-call-action__size_btn_${size}`)
    },
    inputTimer(val, type) {
      const t = typeof val === 'string' ? convertTimeToSeconds(val) : val
      if (t > this.durationVideo) this.formButtonAction[type] = convertSecondsToTime(this.durationVideo)
      else if (t < this.durationVideo) this.formButtonAction[type] = convertSecondsToTime(t)
    },
    resetModal() {
      this.step = 1
      this.triggerEnd = false
      if (!this.isValidForm) this.$store.dispatch('callActions/resetCallActionOffSave')
      this.$store.dispatch('callActions/resetCallAction')
      this.$store.commit('Videos/resetVideoEditAtual')
    },
    async handleSubmit() {
      const ca = this.formButtonAction

      // Normaliza URL: adiciona protocolo se usuário inseriu sem (ex: seusite.com)
      if (ca.link && typeof ca.link === 'string' && ca.link.trim() !== '') {
        let normalized = ca.link.trim()
        if (!/^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//.test(normalized)) {
          normalized = 'https://' + normalized
        }
        this.formButtonAction.link = normalized
      }

      if (!this.$refs.form.checkValidity()) return

      const startVal = typeof ca.start === 'string' ? convertTimeToSeconds(ca.start) : (ca.start || 0)
      const endRaw = ca.end
      let endVal = null
      if (endRaw !== 'Infinito' && endRaw !== null && endRaw !== undefined && endRaw !== '') {
        endVal = typeof endRaw === 'string' ? convertTimeToSeconds(endRaw) : endRaw
        if (startVal > endVal) {
          this.$swal({ title: 'Ops!', text: 'O tempo de termino deve ser maior ou igual ao de inicio', icon: 'error', customClass: { confirmButton: 'btn btn-primary' }, buttonsStyling: false })
          return
        }
      }

      if (ca.id) {
        // Botao existente: atualiza direto na API
        try {
          const api = process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend'
          await fetch(`${api}/call-actions/${ca.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
            body: JSON.stringify({
              ...ca,
              start: startVal,
              end: endVal,
            }),
          })
          // Recarrega a lista
          await this.$store.dispatch('callActions/fetchCallActions', ca.id_vsl)
        } catch (e) {
          console.error('[VSLBooster] Erro ao atualizar CTA:', e)
        }
      } else {
        // Botao novo: adiciona ao array de pendentes
        this.$store.commit('callActions/SET_CALL_ACTIONS_OFF_SAVE')
      }

      this.$nextTick(() => this.$bvModal.hide('modal-add-botoes'))
    },
    transp(delta) {
      const cur = this.formButtonAction.transparencia_btn != null ? this.formButtonAction.transparencia_btn : 10
      this.formButtonAction.transparencia_btn = Math.max(0, Math.min(10, cur + delta))
    },
  },
}
</script>

<template>
  <b-modal
    id="modal-add-botoes"
    ref="modal"
    size="md"
    @show="resetModal"
    @hidden="resetModal"
  >
    <!-- ─── Custom header ─── -->
    <template #modal-header="{ close }">
      <div class="wz-header">
        <div class="wz-header-left">
          <div class="wz-header-icon">
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h4" stroke="#E86A10" stroke-width="2" stroke-linecap="round"/><path d="M12 17V7M12 7l-3 3M12 7l3 3" stroke="#E86A10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <div>
            <div class="wz-title">{{ isEdit ? 'Editar CTA' : 'Novo Botão CTA' }}</div>
            <div class="wz-sub">Passo {{ step }} de {{ totalSteps }} — {{ steps[step-1].label }}</div>
          </div>
        </div>
        <button type="button" class="wz-close" @click="close()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="#94a3b8" stroke-width="2.5" stroke-linecap="round"/></svg>
        </button>
      </div>
    </template>

    <!-- ─── Step indicator ─── -->
    <div class="wz-steps">
      <div v-for="(s, i) in steps" :key="i" class="wz-step" :class="{ 'wz-step-done': step > i+1, 'wz-step-active': step === i+1 }">
        <div class="wz-step-circle">
          <svg v-if="step > i+1" width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <span v-else>{{ i+1 }}</span>
        </div>
        <div class="wz-step-label">{{ s.label }}</div>
        <div v-if="i < steps.length-1" class="wz-step-line"></div>
      </div>
    </div>

    <!-- ─── Form body ─── -->
    <b-form ref="form" @submit.stop.prevent="handleSubmit">
      <div class="wz-body">

        <!-- STEP 1: Posição -->
        <div v-show="step === 1" class="wz-pane">
          <div class="wz-pane-title">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="3" stroke="#E86A10" stroke-width="2"/><path d="M3 9h18M3 15h18M9 3v18M15 3v18" stroke="#E86A10" stroke-width="1.5"/></svg>
            Onde o botao vai aparecer?
          </div>

          <!-- Dentro / Fora do player -->
          <div class="wz-placement-toggle">
            <button type="button" class="wz-placement-btn" :class="{ 'wz-placement-active': formButtonAction.position !== 'outside' }" @click="formButtonAction.position = 'bc'">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" stroke-width="2"/><path d="M8 21h8M12 17v4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
              Dentro do player
            </button>
            <button type="button" class="wz-placement-btn" :class="{ 'wz-placement-active': formButtonAction.position === 'outside' }" @click="formButtonAction.position = 'outside'">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" stroke-width="2"/><path d="M2 21h20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M8 21h8" stroke="#E86A10" stroke-width="3" stroke-linecap="round"/></svg>
              Abaixo do player
            </button>
          </div>

          <!-- Grid de posicao (so mostra se dentro do player) -->
          <template v-if="formButtonAction.position !== 'outside'">
            <div class="wz-pos-layout">
              <div class="wz-pos-grid">
                <button v-for="pos in ['tl','tc','tr','cl','cc','cr','bl','bc','br']" :key="pos" type="button" class="wz-pos-cell" :class="{ 'wz-pos-active': formButtonAction.position === pos }" @click="selectPosition(pos)">
                  <span class="wz-pos-dot"></span>
                </button>
              </div>
              <div class="wz-pos-preview">
                <div class="wz-pos-screen">
                  <div class="wz-pos-indicator" :class="'wz-pi-' + (formButtonAction.position || 'bc')">
                    <div class="wz-pos-tag">CTA</div>
                  </div>
                </div>
                <div class="wz-pos-name">{{ positionNames[formButtonAction.position] || 'Selecione' }}</div>
              </div>
            </div>
          </template>

          <!-- Preview abaixo do player (position === 'outside') -->
          <template v-else>
            <div class="wz-outside-preview">
              <div class="wz-outside-player"></div>
              <div class="wz-outside-btn">{{ formButtonAction.text || 'CTA' }}</div>
            </div>
            <p class="wz-hint">O botao aparecera centralizado abaixo do video.</p>
          </template>
        </div>

        <!-- STEP 2: Conteúdo -->
        <div v-show="step === 2" class="wz-pane">
          <div class="wz-pane-title">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M4 7V4h16v3M9 20h6M12 4v16" stroke="#E86A10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            O que o botão vai dizer?
          </div>

          <div class="wz-field">
            <label class="wz-label">Texto do Botão</label>
            <input v-model="formButtonAction.text" type="text" class="wz-input" placeholder="Ex: Compre agora">
          </div>

          <div class="wz-field">
            <label class="wz-label">Tamanho</label>
            <div class="wz-size-pills">
              <button type="button" class="wz-sz" :class="{ 'wz-sz-on': formButtonAction.size === 'sm' }" @click="changeSize('sm')">Pequeno</button>
              <button type="button" class="wz-sz" :class="{ 'wz-sz-on': !formButtonAction.size || formButtonAction.size === 'md' }" @click="changeSize('md')">Médio</button>
              <button type="button" class="wz-sz" :class="{ 'wz-sz-on': formButtonAction.size === 'lg' }" @click="changeSize('lg')">Grande</button>
            </div>
          </div>

          <div class="wz-field">
            <label class="wz-label">URL de Destino</label>
            <div class="wz-input-wrap">
              <svg class="wz-input-ico" width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
              <input v-model="formButtonAction.link" type="url" class="wz-input wz-input-ico-pad" placeholder="https://seusite.com.br">
            </div>
          </div>
        </div>

        <!-- STEP 3: Timing -->
        <div v-show="step === 3" class="wz-pane">
          <div class="wz-pane-title">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#E86A10" stroke-width="2"/><path d="M12 6v6l4 2" stroke="#E86A10" stroke-width="2" stroke-linecap="round"/></svg>
            Quando o botão aparece?
          </div>

          <div class="wz-row-2">
            <div class="wz-field">
              <label class="wz-label"><span class="wz-dot-green"></span> Início</label>
              <cleave v-model="formButtonAction.start" class="wz-input" :raw="false" :options="{ time: true, timePattern: ['m','s'] }" placeholder="00:00" @blur="inputTimer($event, 'start')" />
            </div>
            <div class="wz-field">
              <label class="wz-label"><span class="wz-dot-red"></span> Término</label>
              <cleave v-if="!triggerEnd" v-model="formButtonAction.end" class="wz-input" :raw="false" :options="{ time: true, timePattern: ['m','s'] }" placeholder="00:00" @blur="inputTimer($event, 'end')" />
              <div v-else class="wz-input wz-inf">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M12 12c-2-2.5-4-4-6-4a4 4 0 000 8c2 0 4-1.5 6-4z" stroke="#94a3b8" stroke-width="2"/><path d="M12 12c2 2.5 4 4 6 4a4 4 0 000-8c-2 0-4 1.5-6 4z" stroke="#94a3b8" stroke-width="2"/></svg>
                Infinito
              </div>
            </div>
          </div>

          <label class="wz-toggle-row">
            <div class="wz-toggle-info">
              <div class="wz-toggle-title">Exibir até o fim do vídeo</div>
              <div class="wz-toggle-sub">O botão fica visível do Início até o final do vídeo</div>
            </div>
            <span class="wz-switch">
              <input type="checkbox" :checked="triggerEnd" @change="toggleTriggerEnd">
              <span class="wz-track"><span class="wz-thumb"></span></span>
            </span>
          </label>
        </div>

        <!-- STEP 4: Visual -->
        <div v-show="step === 4" class="wz-pane">
          <div class="wz-pane-title">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#E86A10" stroke-width="2"/><circle cx="12" cy="12" r="4" fill="#E86A10"/></svg>
            Como o botão vai parecer?
          </div>

          <!-- Preview compacto -->
          <div class="wz-preview">
            <div class="wz-preview-bar">
              <span style="width:8px;height:8px;border-radius:50%;background:#ff5f57;display:block"></span>
              <span style="width:8px;height:8px;border-radius:50%;background:#febc2e;display:block"></span>
              <span style="width:8px;height:8px;border-radius:50%;background:#28c840;display:block"></span>
            </div>
            <div class="wz-preview-screen">
              <a id="btn-preview" class="wz-preview-btn" :style="{ backgroundColor: formButtonAction.background_color, color: formButtonAction.text_color, opacity: opacityBtn }" @click.prevent>{{ formButtonAction.text || 'Compre agora' }}</a>
            </div>
          </div>

          <!-- Cores em linha -->
          <div class="wz-colors-row">
            <div class="wz-color-item">
              <div class="wz-color-lbl">Texto</div>
              <label class="wz-cpick">
                <span class="wz-cswatch" :style="'background:' + formButtonAction.text_color"></span>
                <input type="color" v-model="formButtonAction.text_color" class="wz-cnative">
              </label>
              <div class="wz-chex">{{ formButtonAction.text_color }}</div>
            </div>
            <div class="wz-color-item">
              <div class="wz-color-lbl">Fundo</div>
              <label class="wz-cpick">
                <span class="wz-cswatch" :style="'background:' + formButtonAction.background_color"></span>
                <input type="color" v-model="formButtonAction.background_color" class="wz-cnative">
              </label>
              <div class="wz-chex">{{ formButtonAction.background_color }}</div>
            </div>
            <div class="wz-color-item">
              <div class="wz-color-lbl">Hover</div>
              <label class="wz-cpick">
                <span class="wz-cswatch" :style="'background:' + formButtonAction.background_hover_color"></span>
                <input type="color" v-model="formButtonAction.background_hover_color" class="wz-cnative">
              </label>
              <div class="wz-chex">{{ formButtonAction.background_hover_color }}</div>
            </div>
            <div class="wz-color-item">
              <div class="wz-color-lbl">Opacidade</div>
              <div class="wz-transp">
                <button type="button" class="wz-tb" @click="transp(-1)">−</button>
                <span class="wz-tv">{{ formButtonAction.transparencia_btn != null ? formButtonAction.transparencia_btn : 10 }}</span>
                <button type="button" class="wz-tb" @click="transp(1)">+</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </b-form>

    <!-- ─── Footer navigation ─── -->
    <template #modal-footer>
      <div class="wz-footer">
        <div class="wz-footer-dots">
          <span v-for="i in totalSteps" :key="i" class="wz-fdot" :class="{ 'wz-fdot-on': step === i }"></span>
        </div>
        <div class="wz-footer-btns">
          <button type="button" class="wz-btn-back" :disabled="isFirstStep" @click="prevStep">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
            Voltar
          </button>
          <button v-if="!isLastStep" type="button" class="wz-btn-next" @click="nextStep">
            Próximo
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
          <button v-else type="button" class="wz-btn-save" @click="handleSubmit">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" stroke="currentColor" stroke-width="2"/><path d="M17 21v-8H7v8M7 3v5h8" stroke="currentColor" stroke-width="2"/></svg>
            {{ isEdit ? 'Atualizar' : 'Salvar CTA' }}
          </button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<style>
#modal-add-botoes .modal-content {
  border: none;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.15);
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif;
}
#modal-add-botoes .modal-header {
  padding: 0 !important;
  border: none !important;
  display: block !important;
}
#modal-add-botoes .modal-footer {
  padding: 0 !important;
  border: none !important;
  display: block !important;
}
#modal-add-botoes .modal-body { padding: 0 !important; background: var(--dk-bg-segment, #F4F6F9); }
</style>

<style scoped>
/* ─── Header ─── */
.wz-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 20px 14px; background: var(--dk-bg-card, #fff); border-bottom: 1.5px solid #E4EAF0;
}
.wz-header-left { display: flex; align-items: center; gap: 11px; }
.wz-header-icon {
  width: 38px; height: 38px; border-radius: 10px;
  background: linear-gradient(135deg, #FFF3EA 0%, #FFE8D4 100%);
  border: 1.5px solid var(--dk-border, #F5D5B8);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.wz-title { font-size: 14px; font-weight: 800; color: var(--dk-text-primary, #0D3349); }
.wz-sub   { font-size: 11px; color: var(--dk-text-muted, #94a3b8); margin-top: 1px; }
.wz-close {
  width: 30px; height: 30px; border-radius: 8px; border: 1.5px solid var(--dk-border, #E4EAF0);
  background: var(--dk-bg-page, #F8FAFB); display: flex; align-items: center; justify-content: center;
  cursor: pointer; transition: all 0.15s;
}
.wz-close:hover { border-color: #E86A10; background: #FFF8F3; }

/* ─── Step indicator ─── */
.wz-steps {
  display: flex; align-items: center;
  padding: 12px 20px 10px; background: var(--dk-bg-card, #fff); border-bottom: 1.5px solid #E4EAF0;
  gap: 0;
}
.wz-step { display: flex; align-items: center; flex: 1; position: relative; }
.wz-step:last-child { flex: 0; }
.wz-step-circle {
  width: 26px; height: 26px; border-radius: 50%;
  border: 2px solid #DDE3EA; background: var(--dk-bg-page, #F8FAFB);
  display: flex; align-items: center; justify-content: center;
  font-size: 11px; font-weight: 800; color: var(--dk-text-muted, #94a3b8);
  flex-shrink: 0; transition: all 0.25s; z-index: 1;
}
.wz-step-active .wz-step-circle {
  border-color: #E86A10; background: #E86A10; color: #fff;
  box-shadow: 0 0 0 4px rgba(232,106,16,0.15);
}
.wz-step-done .wz-step-circle { border-color: #16a34a; background: #16a34a; color: #fff; }
.wz-step-label {
  font-size: 10px; font-weight: 700; color: var(--dk-text-faint, #c0c8d4); white-space: nowrap;
  position: absolute; bottom: -16px; left: 50%; transform: translateX(-50%);
  display: none;
}
.wz-step-active .wz-step-label,
.wz-step-done .wz-step-label { display: block; color: var(--dk-text-secondary, #64748b); }
.wz-step-line { flex: 1; height: 2px; background: #E4EAF0; margin: 0 6px; transition: background 0.25s; }
.wz-step-done .wz-step-line { background: #16a34a; }

/* ─── Body ─── */
.wz-body { padding: 18px 20px 4px; min-height: 230px; }
.wz-pane {}
.wz-pane-title {
  display: flex; align-items: center; gap: 7px;
  font-size: 13px; font-weight: 700; color: var(--dk-text-primary, #0D3349);
  margin-bottom: 16px;
}

/* Placement toggle (dentro/fora) */
.wz-placement-toggle { display: flex; gap: 8px; margin-bottom: 16px; }
.wz-placement-btn {
  flex: 1; display: flex; align-items: center; justify-content: center; gap: 8px;
  padding: 12px 16px; border-radius: 10px; cursor: pointer;
  font-size: 12px; font-weight: 600; font-family: inherit;
  background: rgba(255,255,255,0.04); border: 1.5px solid rgba(255,255,255,0.1);
  color: #94a3b8; transition: all 0.2s;
}
.wz-placement-btn:hover { border-color: rgba(255,255,255,0.2); color: #e2e8f0; }
.wz-placement-active {
  background: rgba(232,106,16,0.1) !important; border-color: #E86A10 !important; color: #E86A10 !important;
}

/* Outside preview */
.wz-outside-preview {
  display: flex; flex-direction: column; align-items: center; gap: 10px;
  padding: 20px; background: rgba(255,255,255,0.03); border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.06);
}
.wz-outside-player {
  width: 100%; height: 120px; border-radius: 8px;
  background: linear-gradient(135deg, #1a2535, #0f1a28);
  border: 1px solid rgba(255,255,255,0.08);
}
.wz-outside-btn {
  padding: 8px 24px; border-radius: 8px;
  background: #E86A10; color: #fff; font-size: 12px; font-weight: 700;
}
.wz-hint { font-size: 11px; color: #64748b; margin-top: 8px; text-align: center; }

/* Position grid */
.wz-pos-layout { display: flex; align-items: center; gap: 18px; }
.wz-pos-grid {
  display: grid;
  grid-template-columns: repeat(3, 40px);
  grid-template-rows: repeat(3, 40px);
  gap: 6px; flex-shrink: 0;
}
.wz-pos-cell {
  width: 40px; height: 40px; border-radius: 9px;
  border: 2px solid var(--dk-border, #E4EAF0);
  background: var(--dk-bg-page, #F8FAFB) !important; background-image: none !important;
  cursor: pointer; display: flex; align-items: center; justify-content: center;
  transition: all 0.15s;
}
.wz-pos-cell:hover { border-color: #E86A10; background: #FFF8F3 !important; }
.wz-pos-active { border-color: #E86A10 !important; background: #E86A10 !important; box-shadow: 0 3px 10px rgba(232,106,16,0.35); }
.wz-pos-active .wz-pos-dot { background: var(--dk-bg-card, #fff) !important; }
.wz-pos-dot { width: 9px; height: 9px; border-radius: 50%; background: #DDE3EA; }
.wz-pos-preview { flex: 1; min-width: 0; }
.wz-pos-screen {
  width: 100%; aspect-ratio: 16/9; background: #0D1F2D;
  border-radius: 9px; position: relative; overflow: hidden;
  border: 1.5px solid #1e3547;
}
.wz-pos-indicator { position: absolute; }
.wz-pi-tl { top: 8px; left: 8px; }
.wz-pi-tc { top: 8px; left: 50%; transform: translateX(-50%); }
.wz-pi-tr { top: 8px; right: 8px; }
.wz-pi-cl { top: 50%; left: 8px; transform: translateY(-50%); }
.wz-pi-cc { top: 50%; left: 50%; transform: translate(-50%,-50%); }
.wz-pi-cr { top: 50%; right: 8px; transform: translateY(-50%); }
.wz-pi-bl { bottom: 10px; left: 8px; }
.wz-pi-bc { bottom: 10px; left: 50%; transform: translateX(-50%); }
.wz-pi-br { bottom: 10px; right: 8px; }
.wz-pos-tag {
  background: #E86A10; color: #fff; font-size: 8px; font-weight: 800;
  padding: 3px 8px; border-radius: 4px; white-space: nowrap;
}
.wz-pos-name { text-align: center; font-size: 11px; font-weight: 600; color: var(--dk-text-muted, #94a3b8); margin-top: 6px; }

/* Fields */
.wz-field { margin-bottom: 14px; }
.wz-label {
  display: flex; align-items: center; gap: 5px;
  font-size: 10.5px; font-weight: 700; text-transform: uppercase;
  letter-spacing: 0.07em; color: var(--dk-text-muted, #94a3b8); margin-bottom: 6px;
}
.wz-input {
  width: 100%; border: 1.5px solid var(--dk-border, #E4EAF0); border-radius: 9px;
  padding: 9px 12px; font-size: 13px; color: var(--dk-text-primary, #0D3349);
  background: var(--dk-bg-card, #fff); outline: none; box-sizing: border-box;
  transition: border-color 0.15s, box-shadow 0.15s; font-family: inherit; display: block;
}
.wz-input:focus { border-color: #E86A10; box-shadow: 0 0 0 3px rgba(232,106,16,0.10); }
.wz-input::placeholder { color: var(--dk-text-faint, #c0c8d4); }
.wz-input-wrap { position: relative; }
.wz-input-ico { position: absolute; left: 11px; top: 50%; transform: translateY(-50%); pointer-events: none; }
.wz-input-ico-pad { padding-left: 32px !important; }

/* Size pills */
.wz-size-pills { display: flex; gap: 8px; }
.wz-sz {
  flex: 1; padding: 8px 0; border-radius: 9px;
  border: 1.5px solid #E4EAF0; background: var(--dk-bg-card, #fff) !important; background-image: none !important;
  font-size: 12px; font-weight: 700; color: var(--dk-text-muted, #94a3b8); cursor: pointer; transition: all 0.15s;
}
.wz-sz:hover { border-color: #E86A10; color: #E86A10; }
.wz-sz-on { border-color: #E86A10 !important; background: #E86A10 !important; color: #fff !important; box-shadow: 0 2px 8px rgba(232,106,16,0.30); }

/* Timing */
.wz-row-2 { display: flex; gap: 12px; margin-bottom: 14px; }
.wz-row-2 .wz-field { flex: 1; margin-bottom: 0; }
.wz-dot-green { width: 8px; height: 8px; border-radius: 50%; background: #16a34a; display: inline-block; }
.wz-dot-red   { width: 8px; height: 8px; border-radius: 50%; background: #dc2626; display: inline-block; }
.wz-inf { display: flex; align-items: center; gap: 6px; color: var(--dk-text-muted, #94a3b8); cursor: default; }

.wz-toggle-row {
  display: flex; align-items: center; justify-content: space-between;
  background: var(--dk-bg-card, #fff); border: 1.5px solid #E4EAF0; border-radius: 11px;
  padding: 12px 14px; cursor: pointer; gap: 12px; margin-bottom: 4px;
}
.wz-toggle-info { flex: 1; }
.wz-toggle-title { font-size: 13px; font-weight: 600; color: var(--dk-text-primary, #0D3349); }
.wz-toggle-sub   { font-size: 11px; color: var(--dk-text-muted, #94a3b8); margin-top: 2px; }
.wz-switch { position: relative; flex-shrink: 0; }
.wz-switch input { position: absolute; opacity: 0; width: 0; height: 0; }
.wz-track { display: block; width: 42px; height: 23px; background: #E4EAF0; border-radius: 12px; transition: background 0.25s; position: relative; }
.wz-switch input:checked ~ .wz-track { background: #E86A10; }
.wz-thumb { position: absolute; top: 2.5px; left: 2.5px; width: 18px; height: 18px; border-radius: 50%; background: var(--dk-bg-card, #fff); box-shadow: 0 1px 4px rgba(0,0,0,0.2); transition: transform 0.25s; }
.wz-switch input:checked ~ .wz-track .wz-thumb { transform: translateX(19px); }

/* Visual step */
.wz-preview {
  background: #0D1F2D; border-radius: 10px; overflow: hidden;
  margin-bottom: 14px;
}
.wz-preview-bar { display: flex; align-items: center; gap: 5px; padding: 7px 11px; background: #1e2d3d; }
.wz-preview-screen {
  min-height: 60px; display: flex; align-items: center; justify-content: center; padding: 12px;
}
.wz-preview-btn {
  display: inline-flex; align-items: center; justify-content: center;
  padding: 8px 24px; border-radius: 6px; font-size: 13px; font-weight: 700;
  text-decoration: none; white-space: nowrap; cursor: default; transition: none;
}

/* Colors */
.wz-colors-row { display: flex; gap: 8px; }
.wz-color-item { flex: 1; display: flex; flex-direction: column; align-items: center; gap: 5px; }
.wz-color-lbl  { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: var(--dk-text-muted, #94a3b8); }
.wz-cpick {
  width: 40px; height: 40px; border-radius: 10px; cursor: pointer;
  position: relative; border: 2px solid var(--dk-border, #E4EAF0); overflow: hidden;
  display: flex; align-items: center; justify-content: center;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.wz-cpick:hover { border-color: #E86A10; box-shadow: 0 0 0 3px rgba(232,106,16,0.15); }
.wz-cswatch { width: 100%; height: 100%; display: block; border-radius: 8px; }
.wz-cnative { position: absolute; opacity: 0; width: 200%; height: 200%; top: -50%; left: -50%; cursor: pointer; }
.wz-chex { font-size: 9px; font-family: monospace; color: var(--dk-text-secondary, #64748b); font-weight: 700; }
.wz-transp { display: flex; align-items: center; border: 1.5px solid var(--dk-border, #E4EAF0); border-radius: 9px; overflow: hidden; }
.wz-tb {
  width: 26px; height: 40px; border: none;
  background: var(--dk-bg-page, #F8FAFB) !important; background-image: none !important;
  font-size: 16px; font-weight: 300; color: var(--dk-text-secondary, #64748b); cursor: pointer;
  display: flex; align-items: center; justify-content: center;
}
.wz-tb:hover { background: var(--dk-bg-segment, #F0F3F7) !important; color: #E86A10; }
.wz-tv { min-width: 22px; text-align: center; font-size: 13px; font-weight: 800; color: var(--dk-text-primary, #0D3349); }

/* ─── Footer ─── */
.wz-footer {
  display: flex; align-items: center; justify-content: space-between;
  padding: 12px 20px; background: var(--dk-bg-card, #fff); border-top: 1.5px solid #E4EAF0;
}
.wz-footer-dots { display: flex; gap: 5px; align-items: center; }
.wz-fdot { width: 7px; height: 7px; border-radius: 50%; background: #E4EAF0; transition: background 0.2s, width 0.2s; }
.wz-fdot-on { background: #E86A10; width: 18px; border-radius: 4px; }
.wz-footer-btns { display: flex; gap: 8px; }
.wz-btn-back {
  display: flex; align-items: center; gap: 5px;
  padding: 8px 16px; border-radius: 9px;
  border: 1.5px solid #E4EAF0; background: var(--dk-bg-page, #F8FAFB);
  font-size: 12.5px; font-weight: 600; color: var(--dk-text-secondary, #64748b); cursor: pointer; transition: all 0.15s;
}
.wz-btn-back:hover:not(:disabled) { border-color: #94a3b8; color: var(--dk-text-primary, #0D3349); }
.wz-btn-back:disabled { opacity: 0.4; cursor: not-allowed; }
.wz-btn-next {
  display: flex; align-items: center; gap: 5px;
  padding: 8px 18px; border-radius: 9px;
  border: none; background: #0D3349;
  font-size: 12.5px; font-weight: 700; color: #fff; cursor: pointer; transition: all 0.15s;
}
.wz-btn-next:hover { background: #0f3d5c; }
.wz-btn-save {
  display: flex; align-items: center; gap: 6px;
  padding: 8px 18px; border-radius: 9px;
  border: none; background: #E86A10;
  font-size: 12.5px; font-weight: 700; color: #fff; cursor: pointer;
  box-shadow: 0 2px 10px rgba(232,106,16,0.35); transition: all 0.15s;
}
.wz-btn-save:hover { background: #d15e0d; }
</style>
